import dayjs from "dayjs";

import { DATE_FORMAT, SERVER_DATE_FORMAT, DATE_FORMAT_FULL } from "constants/variables";

export function formatDate(dateString, full = false) {
  return dayjs(dateString, { format: SERVER_DATE_FORMAT }).format(full ? DATE_FORMAT_FULL : DATE_FORMAT);
}

export function displayDuration(seconds = 0) {
  return new Date(seconds * 1000).toISOString().substr(11, 8);
}
